
import Button from '../../../components/base/Button';

export default function ClientPortalSection() {
  return (
    <section id="client-portal" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Client Support
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Access the support portal to submit tickets and track status, or join a secure remote support session.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Freshservice Support Widget */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Submit a Support Request</h3>
            <iframe 
              className="freshwidget-embedded-form" 
              id="freshwidget-embedded-form" 
              src="https://servicedesk.tekrva.com/widgets/feedback_widget/new?&widgetType=embedded&formTitle=Request%20Support&submitThanks=Thank%20you.%20Someone%20will%20be%20in%20contact%20with%20you%20shortly.&screenshot=no&attachFile=no&searchArea=no" 
              scrolling="no" 
              height="500px" 
              width="100%" 
              frameBorder="0"
              title="Submit Support Request Form - Create and track support tickets"
            />
          </div>

          {/* Zoho Remote Support */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Remote Support Access</h3>
            <p className="text-gray-600 mb-4 text-center">Get instant remote assistance from our technical team</p>
            <iframe 
              width="100%" 
              height="150px" 
              src="https://assist.zoho.com/login/embed-remote-support.jsp" 
              frameBorder="0"
              className="rounded-lg border border-gray-200"
              title="Zoho Remote Support Access - Connect for live technical assistance"
            />
            <div className="mt-4 p-4 bg-blue-50 rounded-lg">
              <div className="flex items-center text-blue-800">
                <i className="ri-information-line mr-2"></i>
                <span className="text-sm font-medium">Secure remote access for faster problem resolution</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
